<template>
  <div>
    <div style="margin-bottom:10px;">
      <el-radio-group v-model="type" size="small">
        <el-radio-button label="0">Sales assign history</el-radio-button>
        <el-radio-button label="1">Company information history</el-radio-button>
        <el-radio-button label="2">Contact person history</el-radio-button>
      </el-radio-group>
    </div>
    <div v-if="type === '0'">
      <table class="normal-table">
        <tr>
          <th>Time</th>
          <th>Modified by</th>
          <th>Sales 1</th>
          <th>Sales 2</th>
        </tr>
        <tr v-for="item in list" :key="item.id">
          <td>{{ item.oper_time }}</td>
          <td>{{ item.oper_name }}</td>
          <td>{{ item.new_sales_name }}</td>
          <td>{{ item.new_sales2_name }}</td>
        </tr>
      </table>
      <no-data :loading="loading" :list="list"></no-data>
    </div>
  </div>
</template>

<script>
import NoData from '@/components/NoData'
export default {
  components: {
    NoData
  },
  data () {
    return {
      type: '0',
      list: [],
      loading: false
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    }
  },
  watch: {
    type () {
      this.fetch()
    }
  },
  mounted () {
    this.fetch()
  },
  methods: {
    fetch () {
      this.loading = true
      this.list = []
      let url = '/dbapi/company_sales_change?company_id=' + this.$route.params.id
      if (this.type === '1') {
        url = ''
        this.loading = false
        return //TODO
      } else if (this.type === '2') {
        url = ''
        this.loading = false
        return //TODO
      }
      this.$http.get(url).then(data => {
        this.loading = false
        this.list = data.list
      })
    }
  }
}
</script>